import { MFE_REMOTES } from './mfeRemotes'

type MfeUrls = Record<string, string>

let localUrls: MfeUrls = {}
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  localUrls = require('./mfeLocalUrls') as MfeUrls
} catch {}
/**
 * Use mfeLocalUrls.js to point at local MFEs without the MFE Loader plugin.
 * Create entries like: module.exports = { contrastBase: 'http://localhost:8081/mf-manifest.json' }
 */

// MF2 fetches manifests (CORS), so every server proxies or hosts /Contrast/mfe same-origin.
export const getDefaultUrl = (): MfeUrls =>
  Object.fromEntries(
    Object.entries(MFE_REMOTES).map(([name, path]) => [
      name,
      `/Contrast/mfe/${path}`
    ])
  )

export const getUrl = (): MfeUrls => {
  if (window.__MFE__ && Object.keys(window.__MFE__).length !== 0) {
    return { ...getDefaultUrl(), ...window.__MFE__ }
  }

  if (Object.keys(localUrls).length > 0) {
    return { ...getDefaultUrl(), ...localUrls }
  }

  let previousMFESettings: MfeUrls | null = null
  try {
    const storedSettings = localStorage.getItem('mfeUrls')
    if (storedSettings) {
      previousMFESettings = JSON.parse(storedSettings) as MfeUrls
    }
  } catch {}

  if (previousMFESettings && Object.keys(previousMFESettings).length !== 0) {
    return { ...getDefaultUrl(), ...previousMFESettings }
  }

  return getDefaultUrl()
}

// Set on window so Chrome extensions and the MF runtime plugin can access these
window.getDefaultUrl = getDefaultUrl
window.getUrl = getUrl
